define(
    'viewmodels/secured/help/help',[
        "viewmodels/ViewModel"
    ],
    function(ViewModel) {
        return new ViewModel({ hasCodeBehind: true });
    }
);
